import React from 'react'
import SocialIcons from './SocialIcons'
import PythonSvg from '../svgs/PythonSvg';
import DjangoSvg from '../svgs/DjangoSvg';
import FlaskSvg from '../svgs/FlaskSvg';
import ReactSvg from '../svgs/ReactSvg';
import NextjsSvg from '../svgs/NextjsSvg';
import ProjectSvg from '../svgs/ProjectSvg';
import OpenAISvg from '../svgs/OpenAISvg';

const ProjectComponentLeft = (props) => {

    const componentMap = {
        "python": <PythonSvg customSize={"80px"} />,
        "django": <DjangoSvg customSize={"80px"} />,
        "flask": <FlaskSvg customSize={"80px"} />,
        "react": <ReactSvg customSize={"80px"} />,
        "nextjs": <NextjsSvg customSize={"80px"} />,
        "personal": <ProjectSvg customSize={"80px"} />,
        "openai": <OpenAISvg customSize={"80px"} />
    }

    let componentSvg = componentMap[props.data.project_logo]

    return (
        <div style={{ height: "100%", width: "100%", position: "relative", border: "1px solid white" }} className="card text-bg-dark justify-content-center">
            <div className='text-center'>
                {componentSvg}
                <h6 style={{ color: "#d29345", fontWeight: "bold" }} className="card-title">Project Type: <span className='text-light'>{props.data.project_type}</span></h6>
                <h6 style={{ color: "#d29345", fontWeight: "bold" }} className="card-title">Project Location: <span className='text-light'>{props.data.project_location}</span></h6>
            </div>

        </div>

    )
}

export default ProjectComponentLeft